import { NgModule, Optional, ModuleWithProviders, SkipSelf, inject, provideAppInitializer, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServicesModule } from './services/services.module';
import { EnvironmentFactory } from './environment/environment.factory';
import { EnvironmentService } from './environment/environment.service';
import { EncDecService } from './utils/enc-dec.service';
import { provideNgxWebstorage, withLocalStorage, withNgxWebstorageConfig, withSessionStorage } from 'ngx-webstorage';
import { GlobalErrorHandler } from './error/global-error-handler';

@NgModule({
  imports: [
    CommonModule,
    ServicesModule
  ],
  providers: [
    EncDecService,
    provideAppInitializer(() => {
        const initializerFn = (EnvironmentFactory)(inject(EnvironmentService));
        return initializerFn();
      }),
      provideNgxWebstorage(
      withNgxWebstorageConfig({prefix:'', separator:'', caseSensitive: false }),
      withLocalStorage(), withSessionStorage()),
      {
        provide: ErrorHandler,
        useClass: GlobalErrorHandler
      }
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only'
      );
    }
  }

  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
    };
  }
}
